import React, { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import { Helmet } from 'react-helmet'
import LiveTemplateDefault from 'src/components/template/live'
import { selectParams } from 'src/modules/reducers/params'
import { networkLogos } from 'src/constants'
import { createVideoStructuredData } from 'src/modules/utils/videoStructuredData'

export default (props) => {
  // Detect for fox referral and show banner if redirect from fox domain
  const [foxRedirect, setFoxRedirect] = useState(false)
  const params = useSelector(selectParams)

  useEffect(() => {
    const docReferrer = document && document.referrer
    if ((docReferrer && docReferrer.includes('fox')) || params?.fox_redirect === 'true') {
      setFoxRedirect(true)
    }
  }, [params])

  const offerBanner = {
    title: [
      "You've been redirected to Fubo.",
      'Watch live games, top sports coverage & more right now.',
    ],
  }

  const videoStructuredData = createVideoStructuredData({
    networkName: 'FS1',
    callsign: 'fs1',
    logoUrl: networkLogos.fs1.logoUrl,
    slug: 'fs1',
  })

  return (
    <>
      <Helmet>
        <script type="application/ld+json">{JSON.stringify(videoStructuredData)}</script>
      </Helmet>
      <LiveTemplateDefault
        location={props.location}
        lang="en"
        market="us"
        offerBanner={foxRedirect ? offerBanner : null}
        callsign="fs1"
        title="Watch FS1 live with Fubo"
        foxRedirect={foxRedirect}
        networkName="FS1"
      />
    </>
  )
}
